<template>
  <div class="paginate">
    <b-pagination
      id="top"
      v-model="$store.state.paginationCurrentPage"
      :total-rows="rows"
      :per-page="perPage"
      class="mt-4"
      @input="callPageNumber($store.state.paginationCurrentPage)"
    ></b-pagination>
    <!-- <b-pagination
      id="bottom"
      v-model="$store.state.paginationCurrentPage"
      :total-rows="rows"
      :per-page="perPage"
      class="mt-4"
      @input="callPageNumber($store.state.paginationCurrentPage)"
    ></b-pagination> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      perPage: 6
    };
  },
  methods: {
    callPageNumber(currentPage) {
      let query_string_with_pagination = this.constructURLQueryStringWithPagination(
        currentPage
      );
      return this.$store.commit("callAPI", query_string_with_pagination);
    },
    constructURLQueryStringWithPagination(page_num) {
      let offset_num = page_num * 6 - 6;
      let query_filter_string = "?";
      // console.log(
      //   "Query string on pagination component: " + this.$store.state.queryString
      // );
      if (this.$store.state.queryString) {
        query_filter_string = this.$store.state.queryString + "&";
      }
      let return_query_string =
        this.$store.state.apiURL +
        query_filter_string +
        "limit=6" +
        "&offset=" +
        offset_num;
      // console.log(return_query_string);
      return return_query_string;
    }
  },
  computed: {
    rows() {
      // console.log(this.$store.state.productCount)
      return this.$store.state.productCount;
    }
  }
};


// css

// .paginate {
//   display: block !important;
//   position: absolute;
//   margin-left: 686px;
// }

</script>

<style>
a.page-link {
  color: #1d4679 !important;
}

.page-item.active .page-link {
  background-color: #1d4679 !important;
  border-color: #1d4679 !important;
  color: white !important;
}

.paginate {

}
</style>